export default {
  合: '是否合并订单为是',
  拦: '是否已经拦截为是',
  赠: '是否有赠品为是',
  退: '是否退款中为是',
  拆: '是否拆分订单为是',
  换: '订单类型为换货订单',
  手: '订单来源为“手工新增”',
  票: '顾客需要开发票',
  11: '双11预售状态',
  预: '系统预售状态',
  京: '京仓订单为是',
  催: '是否催发货为是',
  缺: '实缺标记为是',
  代: '是否为分销订单为是',
  到: '付款方式为货到付款',
  工: '是否有工单为是',
  村: '订单来源为“村淘”文字',
  虚: '是否为虚拟标识为是',
  组: '是否为组合商品为是',
  价: '是补差价订单',
  锁: '是订单为锁单状态',
  退回: '发货退回状态为退回',
  超退: '发货退回状态为超时退回',
};
